import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StatsUpdateService } from '../services/stats-update.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private statsUpdate: StatsUpdateService, private router: Router) { }

  canActivate() {
    const password = this.statsUpdate.enteredPassword();
    if (password) {
      return true;
    } else {
      this.router.navigate(['/fix-stats'])
      return false;
    }
  }

}
